const floorStatics = {
  p0_w: {
    sectionPath: '/floor_0',
    locationKey: 'p0_w',
    sectionKey: 'WOMAN',
    floorKey: '0',
    section: 'p0_w.section.name',
    floor: 'p0_w.floor.name',
    title: 'Título de la Planta 0',
    img_banner:
      'https://static.zara.net/photos///2022/V/M/1/p/0000/001/872/2/w/1024/0000001872_15_2_1.jpg?ts=1647362654659',
    img_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3327_P0.jpg?ts=1631201500000',
    pdf_map:
      'https://static.zara.net/photos/contents/multichannel/maps/3327_P0.pdf?ts=1631201500000',
    paths: [
      {
        sectionPath: '/floor_0',
        path: '/mapview',
        exact: true,
        location: 'floorMap',
        linkName: 'p0_w.path.floorMap.linkName',
        title: 'p0_w.path.floorMap.title',
        info: 'p0_w.path.floorMap.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0.jpg?ts=1631201500000',
        description: {
          type: 'default',
          title: 'p0_w.path.floorMap.description.title',
          content: 'p0_w.path.floorMap.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/beauty',
        exact: true,
        location: 'beauty',
        linkName: 'p0_w.path.beauty.linkName',
        title: 'p0_w.path.beauty.title',
        info: 'p0_w.path.beauty.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_Beauty_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_Beauty.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.beauty.description.title',
          content: 'p0_w.path.beauty.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/selfCheckout',
        exact: true,
        location: 'selfCheckout',
        linkName: 'p0_w.path.selfCheckout.linkName',
        title: 'p0_w.path.selfCheckout.title',
        info: 'p0_w.path.selfCheckout.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_Autocobro_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_Autocobro.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.selfCheckout.description.title',
          content: 'p0_w.path.selfCheckout.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/fittingRooms',
        exact: true,
        location: 'fittingRooms',
        linkName: 'p0_w.path.fittingRooms.linkName',
        title: 'p0_w.path.fittingRooms.title',
        info: 'p0_w.path.fittingRooms.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_TurnoProbadores_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_TurnoProbadores.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.fittingRooms.description.title',
          content: 'p0_w.path.fittingRooms.description.content',
        },
      },
      {
        sectionPath: '/floor_0',
        path: '/onlinePickup',
        exact: true,
        location: 'onlinePickup',
        linkName: 'p0_w.path.onlinePickup.linkName',
        title: 'p0_w.path.onlinePickup.title',
        info: 'p0_w.path.onlinePickup.info',
        img_banner:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_PuntoRecogidaOnline_IMG.jpg?ts=1631201500000',
        img_map:
          'https://static.zara.net/photos/contents/multichannel/maps/3327_P0_PuntoRecogidaOnline.jpg?ts=1631201500000',

        description: {
          type: 'default',
          title: 'p0_w.path.onlinePickup.description.title',
          content: 'p0_w.path.onlinePickup.description.content',
        },
      },
    ],
  },
};

const StoreSuportedLanguages = [
  {
    language: 'it-IT',
    name: 'Italiano',
  },
  {
    language: 'en-GB',
    name: 'English',
  },
];

const HomeStatics = {
  splash:
    'https://static.zara.net/photos/contents/multichannel/maps/ZARA_LONDRES___ONC_008.jpg?ts=1631201500000',
  prehome:
    'https://static.zara.net/photos/contents/multichannel/maps/3327_ZARA_BUENOS_AIRES_IMG.jpg?ts=1631201500000',
  prehomeColor: '#fff',
};

const StoreConfig = {
  floorStatics,
  StoreSuportedLanguages,
  HomeStatics,
};

export default StoreConfig;
